import React from "react";

import type { NodesFromEdges } from "~/lib/utils";

import { OLD_TABS_VALUES, RANGE_FILTER_VALUES, RANGE_FILTER_VALUES_IN_WEEKS, TABS_VALUES } from "./constants";

import type { GeneralSectionQuery$data } from "~/__generated__/GeneralSectionQuery.graphql";
import type { MeetingHoursPerDayOfWeekQuery as QueryType } from "~/__generated__/MeetingHoursPerDayOfWeekQuery.graphql";
import type { Members_viewer$data as Viewer } from "~/__generated__/Members_viewer.graphql";

// Tabs
export type TabType = (typeof TABS_VALUES)[number] | (typeof OLD_TABS_VALUES)[number];

export type TabValueType = TabType["key"];
export type TabLabelType = TabType["label"];

// Filters
export type RangeFilterValueType = (typeof RANGE_FILTER_VALUES)[number];
export type RangeFilterValueInWeeksType = (typeof RANGE_FILTER_VALUES_IN_WEEKS)[number];

// Data
export type History = GeneralSectionQuery$data["data"]["activeUsers"]["dailyHistory"];
export type MemberStats = NodesFromEdges<Viewer["data"]>;

// Interfaces
export type ChartProps = {
	className?: string;
};

type AnalyticsContextType = {
	rangeFilter: RangeFilterValueType;
	otherUserId?: string;
	hasAccessToAnalytics: boolean;
	useHierarchy: boolean;
};

export const AnalyticsContext = React.createContext<AnalyticsContextType>({
	rangeFilter: RANGE_FILTER_VALUES[2],
	otherUserId: undefined,
	hasAccessToAnalytics: false,
	useHierarchy: true,
});

export type DAY = keyof QueryType["response"]["data"]["oneononeAvg"];
